import { useState, useEffect, useCallback } from 'react'
import { Outlet, useLocation } from 'react-router'
import { Sidebar } from './Sidebar'
import { TopNavbar } from './TopNavbar'
import { GlobalAnnouncementPopup } from './GlobalAnnouncementPopup'
import { DpaBanner } from './DpaBanner'
import { NetworkStatus } from './NetworkStatus'

export function MainLayout() {
  const location = useLocation()

  // Desktop: collapsed (icone senza testo)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() =>
    localStorage.getItem('sidebar-collapsed') === 'true'
  )

  // Mobile/Tablet (<992px): sidebar aperta/chiusa come overlay
  const [mobileOpen, setMobileOpen] = useState(false)

  const isMobile = useCallback(() => window.innerWidth < 992, [])

  useEffect(() => {
    localStorage.setItem('sidebar-collapsed', String(sidebarCollapsed))
    if (sidebarCollapsed) {
      document.documentElement.classList.add('sidebar-will-collapse')
    } else {
      document.documentElement.classList.remove('sidebar-will-collapse')
    }
  }, [sidebarCollapsed])

  // Chiudi sidebar mobile su navigazione
  useEffect(() => {
    setMobileOpen(false)
  }, [location.pathname])

  const toggleSidebar = () => {
    if (isMobile()) {
      setMobileOpen((prev) => !prev)
    } else {
      setSidebarCollapsed((prev) => !prev)
    }
  }

  return (
    <>
      <GlobalAnnouncementPopup />
      <DpaBanner />
      <NetworkStatus />

      {/* Sidebar Overlay (mobile/tablet) */}
      <div
        className={`sidebar-overlay${mobileOpen ? ' show' : ''}`}
        id="sidebarOverlay"
        onClick={() => setMobileOpen(false)}
      ></div>

      <Sidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileOpen}
        onToggle={toggleSidebar}
      />

      <div className="main-wrapper" id="mainWrapper">
        <TopNavbar onToggleSidebar={toggleSidebar} />

        <main className="main-content">
          <Outlet />
        </main>

        <footer className="main-footer py-3 text-center text-muted">
          <small>&copy; {new Date().getFullYear()} DomusAurea. Tutti i diritti riservati.</small>
        </footer>
      </div>
    </>
  )
}
